import {
    SquareTerminal,
    FileBarChart2,
    Workflow,
    ClipboardList,
    Building2,
    Boxes,
    Inbox,
    ChevronDown,
    Settings,
    BellIcon,
    CreditCard,
} from "lucide-react";

export const sidebarMenus = {
    navMain: [
        {
            title: "Dashboard",
            url: "/branch/dashboard",
            icon: SquareTerminal,
            isActive: true,
        },
        {
            title: "Reports",
            url: "/branch/reports",
            icon: FileBarChart2,
        },
        {
            title: "Automations",
            url: "/branch/automations",
            icon: Workflow,
        },
    ],
    navViews: {
        label: "Views",
        icon: ChevronDown,
    },
    navBelowViews: [
        {
            title: "Purchase Orders",
            url: "/branch/purchase-orders",
            icon: ClipboardList,
        },
        {
            title: "Purchase Invoice",
            url: "/branch/purchase-invoices",
            icon: CreditCard,
        },
        {
            title: "Accounts",
            url: "/branch/accounts",
            icon: Building2,
        },
        {
            title: "Inventory",
            url: "/branch/inventory",
            icon: Boxes,
        },
    ],
    navSecondary: [
        {
            title: "Notifications",
            url: "/notification",
            icon: BellIcon,
        },
        {
            title: "Settings",
            url: "/settings/general",
            icon: Settings,
        },
    ],
};